import { defineStore } from "pinia";
import { markRaw } from "vue";
import { api, type FileDownload, type QueryParams } from "../api";

function normalizeEndpoint(endpoint: string): string {
  return endpoint.endsWith("/") ? endpoint : `${endpoint}/`;
}

class TableTransferApi {
  importXlsx(endpoint: string, file: File) {
    const formData = new FormData();
    formData.append("file", file);
    return api.postFormData(normalizeEndpoint(endpoint) + "import/", formData);
  }

  exportXlsx(endpoint: string, queryParams?: QueryParams) {
    return api.getBlob(normalizeEndpoint(endpoint) + "export/", queryParams);
  }

  saveFile(download: FileDownload, fallbackFilename: string) {
    const url = URL.createObjectURL(download.blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = download.filename || fallbackFilename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}

const store = defineStore("table-transfer", () => ({
  api: markRaw(new TableTransferApi()),
}));

export function useTableTransfer() {
  return store().api;
}
